import { render, staticRenderFns } from "./Editor2.vue?vue&type=template&id=775c0868&scoped=true&"
import script from "./Editor2.vue?vue&type=script&lang=js&"
export * from "./Editor2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "775c0868",
  null
  
)

export default component.exports